export const BASE_URL = 'http://13.50.11.124:5353/api'
//export const BASE_URL = 'http://localhost:5353/api'


